import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, Snackbar,
  TextField,
} from "@mui/material";
import React, {useContext, useState} from "react";
import {useTranslation} from "react-i18next";
import {useMutation} from "@tanstack/react-query";
import {ApiContext} from "../../context/Api.jsx";

function QuestionHelp({ block }) {
  const { t } = useTranslation();
  const { apiService } = useContext(ApiContext);
  const [open, setOpen] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [email, setEmail] = useState('');
  const [explanation, setExplanation] = useState('');

  const closeModal = () => setOpen(false);
  const openModal = () => setOpen(true);

  const onSubmit = useMutation({
    mutationFn: () =>
      apiService.sendEmail(
        import.meta.env.VITE_CONTACT_TO.split(','),
        'Question Confusing',
        `
        Question Id: ${block.name} <br/>
        Question: ${block.content} <br/>
        Confusion: ${explanation}
        `,
        {
          replyTo: email,
        }
      ),
    onSuccess: () => {
      setShowSuccess(true);
    },
    onError: (error) => {
      console.error(error);
    },
    onSettled: () => {
      closeModal();
    },
  });

  return (
    <React.Fragment>
      <Button onClick={openModal}>{t('lesson.question.needHelp')}</Button>

      <Dialog open={open} onClose={closeModal}>
        <DialogTitle>{t('lesson.question.askForHelp')}</DialogTitle>
        <DialogContent sx={{ paddingBottom: 0, minWidth: '300px' }}>
          <TextField
            autoFocus
            variant="filled"
            label={t('lesson.question.yourEmailOptional')}
            placeholder="name@example.com"
            defaultValue={email}
            type="email"
            fullWidth
            onChange={e => setEmail(e.target.value)}
            sx={{marginBlockEnd: '1rem' }}
            slotProps={{
              htmlInput: {
                inputMode: "email",
                enterKeyHint: "next",
              }
            }}
          />
          <TextField
            variant="filled"
            label={t('lesson.question.explainWhatIsConfusing')}
            multiline
            minRows={4}
            fullWidth
            onChange={e => setExplanation(e.target.value)}
          />

          <DialogActions>
            <Button onClick={closeModal}>
              {t('core.close')}
            </Button>

            <Button
              variant="contained"
              onClick={onSubmit.mutate}
              loading={onSubmit.isPending}
            >{t('lesson.question.askForHelp')}</Button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Snackbar
        open={showSuccess}
        autoHideDuration={3000}
        onClose={() => setShowSuccess(false)}
      >
        <Alert
          onClose={() => setShowSuccess(false)}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          {t('lesson.question.helpEmailSent')}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
}
export default QuestionHelp;
